
import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/home-page/index.vue'; // 需提前创建组件文件
// import About from '../views/About.vue';

const routes = [
  { path: '/', name: 'Home', component: HomeView },
//   { path: '/about', name: 'About', component: About }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
